import React, { useState } from "react";
import { Link } from "react-router-dom";
import { postJSON } from "../services/api";
import "./LoginPage.css";

export default function PasswordRecoveryPage({ reset = false }) {
  const [token] = useState(() => new URLSearchParams(window.location.hash.slice(1)).get("token") || "");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(event) {
    event.preventDefault();
    setError("");
    if (reset && password !== confirm) {
      setError("The passwords do not match.");
      return;
    }
    setLoading(true);
    try {
      const result = await postJSON(reset ? "/api/auth/reset-password" : "/api/auth/forgot-password",
        reset ? { token, new_password: password, confirm_password: confirm } : { email: email.trim().toLowerCase() });
      setMessage(result.message);
      if (reset) {
        setPassword("");
        setConfirm("");
        window.history.replaceState(null, "", window.location.pathname);
      }
    } catch (err) {
      setError(String(err.message || "Unable to complete the request. Please try again."));
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="ll-wrap">
      <section className="ll-card">
        <h1 className="ll-title">{reset ? "Reset your password" : "Forgot password?"}</h1>
        <p className="ll-sub">{reset ? "Choose a new HIRI password with at least 8 characters." : "Enter your HIRI email address and we’ll send you a reset link."}</p>
        {message ? <p role="status">{message}</p> : reset && !token ? (
          <p role="alert" className="ll-error">This reset link is invalid. <Link to="/forgot-password">Request a new link</Link>.</p>
        ) : (
          <form className="ll-form" onSubmit={submit}>
            {reset ? <>
              <label className="ll-label" htmlFor="new-password">New password</label>
              <input className="ll-input" id="new-password" type="password" autoComplete="new-password" required minLength={8} maxLength={72} value={password} onChange={e => setPassword(e.target.value)} />
              <label className="ll-label" htmlFor="confirm-password">Confirm password</label>
              <input className="ll-input" id="confirm-password" type="password" autoComplete="new-password" required maxLength={72} value={confirm} onChange={e => setConfirm(e.target.value)} />
            </> : <>
              <label className="ll-label" htmlFor="recovery-email">Email</label>
              <input className="ll-input" id="recovery-email" type="email" autoComplete="email" required maxLength={254} value={email} onChange={e => setEmail(e.target.value)} />
            </>}
            {error && <p role="alert" className="ll-error">{error}</p>}
            <button className="ll-cta" disabled={loading} type="submit">{loading ? "Please wait..." : reset ? "Reset password" : "Send reset link"}</button>
          </form>
        )}
        {!reset && <p className="ll-sub">If you use Google to sign in, continue with “Sign in with Google” on the login page.</p>}
        {reset && error && <p><Link to="/forgot-password">Request a new reset link</Link></p>}
        <p><Link className="ll-link" to="/login">Back to login</Link></p>
      </section>
    </main>
  );
}
